import { render, staticRenderFns } from "./CrudStepperItems.vue?vue&type=template&id=417a0036&"
import script from "./CrudStepperItems.vue?vue&type=script&lang=ts&"
export * from "./CrudStepperItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports